import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white font-['Montserrat',sans-serif]">
      <Navbar />

      {/* Hero Section */}
      <section className="relative w-full h-[460px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/79e3df398e8a622e13a0466c02d6351b.jpg"
          alt="Mastro Minds Hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40" />
      </section>

      {/* Main Content */}
      <main className="flex-1 w-full">
        {/* About Sidebar Content */}
        <div className="w-full border-t border-gray-100 bg-gray-50">
          <div className="max-w-4xl mx-auto px-8 py-10">
            <h3 className="text-sm font-bold tracking-widest text-gray-900 uppercase mb-3">
              Mastro Minds, LLC
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Welcome to Mastro Minds, LLC&apos;s website. Mastro Minds is a holding corporation for various services and products. We strive on finding ways to help our customers become successful in various markets.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
